var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 100.0 119.06299212598425",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l100.0 0l0 119.062996l-100.0 0l0 -119.062996z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l100.0 0l0 119.062996l-100.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "m10.692913 14.980577l0 0c0 -7.23638 5.8662453 -13.102625 13.102625 -13.102625l52.40892 0l0 0c3.4750366 0 6.8077393 1.380451 9.264954 3.8376696c2.457222 2.4572186 3.8376694 5.789922 3.8376694 9.2649555l0 89.10184c0 7.2363815 -5.8662415 13.102623 -13.102623 13.102623l-52.40892 0c-7.2363796 0 -13.102625 -5.8662415 -13.102625 -13.102623z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m10.692913 14.980577l0 0c0 -7.23638 5.8662453 -13.102625 13.102625 -13.102625l52.40892 0l0 0c3.4750366 0 6.8077393 1.380451 9.264954 3.8376696c2.457222 2.4572186 3.8376694 5.789922 3.8376694 9.2649555l0 89.10184c0 7.2363815 -5.8662415 13.102623 -13.102623 13.102623l-52.40892 0c-7.2363796 0 -13.102625 -5.8662415 -13.102625 -13.102623z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m29.921259 22.485565l4.000002 -7.1338587l4.0 7.1338587l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m29.921259 22.485565l4.000002 -7.1338587l4.0 7.1338587l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m61.90026 22.485565l4.0 -7.1338587l4.0 7.1338587l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m61.90026 22.485565l4.0 -7.1338587l4.0 7.1338587l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m61.90026 59.531498l4.0 -7.1338615l4.0 7.1338615l-4.0 7.133854z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m61.90026 59.531498l4.0 -7.1338615l4.0 7.1338615l-4.0 7.133854z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m29.921259 59.531498l4.000002 -7.1338615l4.0 7.1338615l-4.0 7.133854z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m29.921259 59.531498l4.000002 -7.1338615l4.0 7.1338615l-4.0 7.133854z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m29.921259 94.632545l4.000002 -7.1338577l4.0 7.1338577l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m29.921259 94.632545l4.000002 -7.1338577l4.0 7.1338577l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m61.90026 94.632545l4.0 -7.1338577l4.0 7.1338577l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m61.90026 94.632545l4.0 -7.1338577l4.0 7.1338577l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m78.29396 91.62467l1.5118103 -2.6929169l1.5118179 2.6929169l-1.5118179 2.6929169z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m78.29396 91.62467l1.5118103 -2.6929169l1.5118179 2.6929169l-1.5118179 2.6929169z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m18.0 25.847769l1.5118103 -2.692913l1.5118122 2.692913l-1.5118122 2.692913z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m18.0 25.847769l1.5118103 -2.692913l1.5118122 2.692913l-1.5118122 2.692913z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m7.3708973 0.06824147l22.393702 0l0 32.31496l-22.393702 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m19.308397 19.43324q-0.84375 0 -1.375 -0.359375q-0.515625 -0.375 -0.765625 -1.015625q-0.25 -0.640625 -0.25 -1.453125l0 -3.125q0 -0.84375 0.203125 -1.5q0.203125 -0.671875 0.703125 -1.046875q0.515625 -0.375 1.484375 -0.375q0.828125 0 1.296875 0.265625q0.484375 0.25 0.6875 0.75q0.203125 0.484375 0.203125 1.203125q0 0.046875 0 0.078125q0.015625 0.03125 0.015625 0.0625l-1.671875 0q0 -0.515625 -0.09375 -0.765625q-0.078125 -0.25 -0.4375 -0.25q-0.234375 0 -0.359375 0.15625q-0.125 0.140625 -0.171875 0.515625q-0.046875 0.375 -0.046875 1.046875l0 0.765625q0.140625 -0.21875 0.421875 -0.34375q0.28125 -0.125 0.65625 -0.140625q0.671875 -0.015625 1.078125 0.3125q0.421875 0.328125 0.59375 0.90625q0.1875 0.5625 0.1875 1.265625q0 0.90625 -0.21875 1.59375q-0.203125 0.6875 -0.71875 1.078125q-0.515625 0.375 -1.421875 0.375zm0.03125 -1.3125q0.234375 0 0.34375 -0.15625q0.125 -0.171875 0.15625 -0.484375q0.03125 -0.328125 0.03125 -0.8125q0 -0.421875 -0.03125 -0.734375q-0.015625 -0.3125 -0.140625 -0.484375q-0.109375 -0.171875 -0.390625 -0.171875q-0.125 0 -0.25 0.046875q-0.109375 0.046875 -0.203125 0.140625q-0.078125 0.078125 -0.125 0.140625l0 1.40625q0 0.296875 0.046875 0.5625q0.0625 0.25 0.1875 0.40625q0.140625 0.140625 0.375 0.140625z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m92.57006 117.46372l-22.3937 0l0 -32.314964l22.3937 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m80.63256 98.09872q0.84375 0 1.375 0.359375q0.515625 0.375 0.765625 1.015625q0.25 0.640625 0.25 1.453125l0 3.125q0 0.84375 -0.203125 1.5q-0.203125 0.671875 -0.703125 1.046875q-0.515625 0.375 -1.484375 0.375q-0.828125 0 -1.296875 -0.265625q-0.484375 -0.25 -0.6875 -0.75q-0.203125 -0.484375 -0.203125 -1.203125q0 -0.046875 0 -0.078125q-0.015625 -0.03125 -0.015625 -0.0625l1.671875 0q0 0.515625 0.09375 0.765625q0.078125 0.25 0.4375 0.25q0.234375 0 0.359375 -0.15625q0.125 -0.140625 0.171875 -0.515625q0.046875 -0.375 0.046875 -1.046875l0 -0.765625q-0.140625 0.21875 -0.421875 0.34375q-0.28125 0.125 -0.65625 0.140625q-0.671875 0.015625 -1.078125 -0.3125q-0.421875 -0.328125 -0.59375 -0.90625q-0.1875 -0.5625 -0.1875 -1.265625q0 -0.90625 0.21875 -1.59375q0.203125 -0.6875 0.71875 -1.078125q0.515625 -0.375 1.421875 -0.375zm-0.03125 1.3125q-0.234375 0 -0.34375 0.15625q-0.125 0.171875 -0.15625 0.484375q-0.03125 0.328125 -0.03125 0.8125q0 0.421875 0.03125 0.734375q0.015625 0.3125 0.140625 0.484375q0.109375 0.171875 0.390625 0.171875q0.125 0 0.25 -0.046875q0.109375 -0.046875 0.203125 -0.140625q0.078125 -0.078125 0.125 -0.140625l0 -1.40625q0 -0.296875 -0.046875 -0.5625q-0.0625 -0.25 -0.1875 -0.40625q-0.140625 -0.140625 -0.375 -0.140625z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSix);
export default __webpack_public_path__ + "static/media/Six.c45f94ca33ab909b5e6dd97a29630b09.svg";
export { ForwardRef as ReactComponent };